import { useLocation } from 'react-router-dom';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';

import Flex from '@Components/Bases/Flex';
import ApprovalReport from './Containers/ApprovalReport';
import PublishReport from './Containers/PublishReport';
import ReviewReport from './Containers/ReviewReport';
import ReviewSummaryReportFooter from './Containers/ReviewSummaryReportFooter';
import ReviewSummaryReportFormProvider from './Containers/ReviewSummaryReportFormProvider';
import { mapReviewSummaryReportToFormValues } from './utils';
import { useReviewSummaryReport } from './Containers/ReviewSummaryReportProvider/ReviewSummaryReportProvider';

const ReviewSummaryReportSections = () => {
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();
  const { summaryData, loading, error, triggerRefetch } =
    useReviewSummaryReport();

  useEffect(() => {
    if (currentPath === 'review-summary-report' && triggerRefetch) {
      triggerRefetch();
    }
  }, [currentPath]);

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Alert severity={'error'}>ไม่สามารถโหลดข้อมูลรายงานได้</Alert>
      </Box>
    );
  }

  const initialSummaryFormValues =
    mapReviewSummaryReportToFormValues(summaryData);
  const isCgrScorePass = initialSummaryFormValues?.cgrScoreStatus;

  return (
    <ReviewSummaryReportFormProvider initialValues={initialSummaryFormValues}>
      <Flex flexDirection={'column'} gap={2} p={2} mb={8}>
        <Typography variant="h3">
          ขั้นตอนการนำส่งรายงาน Corporate Value Up
        </Typography>
        <ReviewReport />
        {isCgrScorePass && <ApprovalReport />}
        {isCgrScorePass && <PublishReport />}
      </Flex>
      <ReviewSummaryReportFooter />
    </ReviewSummaryReportFormProvider>
  );
};

export default ReviewSummaryReportSections;
